<template>
  <div>
    <v-radio-group v-model="direction">
      <v-radio
        v-for="(direction,i) in directions"
        :key="i"
        :label="direction"
        :value="direction"
      />
    </v-radio-group>
    <AccessPermitRequestGatePass />
    <GenericTextField
      :model="gate_in.vessel_name"
      label="Vessel Name"
    />
    <GenericTextField
      :model="gate_in.voyage_number"
      label="Voyage Number"
    />
    <GenericTextField
      :model="gate_in.container.number"
      label="Container #"
    />
    <ContainerSizeSelector
      :model="gate_in.container.size"
    />
    <ContainerTypeSelector
      :model="gate_in.container.type"
    />
    <ContainerStatusSelector
      :model="gate_in.container.status"
    />
    <v-btn
      text
      color="primary"
    >
      Add container
    </v-btn>
    <v-file-input
      accept="image/*"
      label="Document of Terminal Operator"
      show-size
    />
    <GenericTextField
      :model="gate_in.vehicle.number_plate"
      label="Vehicle number plate"
    />
    <GenericTextField
      :model="gate_in.vehicle.driver.sur_name"
      label="Vehicle driver surname"
    />
    <GenericTextField
      :model="gate_in.vehicle.driver.given_name"
      label="Vehicle driver givenname"
    />
    <v-textarea
      v-model="gate_in.details_of_visit"
      label="Details of visit"
      outlined
    />
  </div>
</template>

<script>
import AccessPermitRequestGatePass from './AccessPermitRequestGatePass';
import ContainerSizeSelector from './ContainerSizeSelector';
import ContainerTypeSelector from './ContainerTypeSelector';
import ContainerStatusSelector from './ContainerStatusSelector';
import GenericTextField from './GenericTextField';


export default {
  name: 'AccessPermitRequestContainer',
  components: {
    AccessPermitRequestGatePass,
    ContainerTypeSelector,
    ContainerSizeSelector,
    ContainerStatusSelector,
    GenericTextField,
  },
  data: () => ({
    gate_in: {
      vessel_name: '',
      voyage_number: '',
      container: {
        number: '',
        size: '',
        type: '',
      },
      vehicle: {
        number_plate: '',
        driver: {
          sur_name: '',
          given_name: '',
        },
      },
      details_of_visit: '',
    },
    gate_out: {
    },
    direction: '',
    directions: [
      'In',
      'Out',
      'In and Out',
    ],
  }),
};
</script>

<style scoped>

</style>
